query job($where: JobModelFilterInput) {
    model: job2(
        where: $where
    ) {
        codigo        
        status
        resultado
    }
}